<div class="import-mapping-modal">
  <!-- Drop zone -->
  <div
    class="import-mapping-modal__dropzone"
    [class.import-mapping-modal__dropzone--over]="isDragOver"
    [class.import-mapping-modal__dropzone--loaded]="!!fileName"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave()"
    (drop)="onDrop($event)"
    (click)="triggerFileInput(fileInput)"
  >
    <input #fileInput type="file" accept=".json,application/json" hidden (change)="onFileSelected($event)" />
    @if (!fileName) {
      <mat-icon class="import-mapping-modal__dropzone-icon">upload_file</mat-icon>
      <p class="import-mapping-modal__dropzone-text">Drag &amp; drop a mapping JSON file here, or click to browse</p>
    } @else {
      <mat-icon class="import-mapping-modal__dropzone-icon">description</mat-icon>
      <p class="import-mapping-modal__dropzone-text">{{ fileName }}</p>
      <p class="import-mapping-modal__dropzone-hint">Click to replace</p>
    }
  </div>

  <!-- Validation error -->
  @if (errorMessage) {
    <div class="import-mapping-modal__error">
      <mat-icon>error</mat-icon>
      <span>{{ errorMessage }}</span>
    </div>
  }

  <!-- Valid preview -->
  @if (isValid && previewJson) {
    <div class="import-mapping-modal__preview">
      <p class="import-mapping-modal__preview-label">
        <mat-icon>check_circle</mat-icon>
        Mapping looks good — click Import to save as a new version
      </p>
      <pre class="import-mapping-modal__json">{{ previewJson }}</pre>
    </div>
  }
</div>
